// ============================================
// MOBİL ALT TAB BAR
// ============================================

import { Link, useLocation } from '@tanstack/react-router';
import { LayoutDashboard, Briefcase, FileText, User, Menu } from 'lucide-react';
import { cn } from '@/utils';
import { useTranslation } from '@crew-at-sea/i18n';

interface MobileTabBarProps {
  onMoreClick: () => void;
}

export function MobileTabBar({ onMoreClick }: MobileTabBarProps) {
  const { t } = useTranslation('panel');
  const location = useLocation();

  const tabs = [
    { name: t('sidebar.dashboardShort', { defaultValue: 'Ana Sayfa' }), href: '/', icon: LayoutDashboard },
    { name: t('sidebar.jobs'), href: '/jobs', icon: Briefcase },
    { name: t('sidebar.applications'), href: '/applications', icon: FileText },
    { name: t('sidebar.myProfile'), href: '/profile', icon: User },
  ];

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  // "Daha Fazla" sekmesi aktif mi? (sidebar'daki diğer sayfalar)
  const isMoreActive = ['/favorites', '/companies', '/notifications', '/settings', '/profile/certificates', '/profile/documents', '/profile/references', '/profile/sea-service']
    .some(p => location.pathname.startsWith(p));

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => (
          <Link
            key={tab.href}
            to={tab.href}
            className={cn(
              'flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors',
              isActive(tab.href)
                ? 'text-maritime-600'
                : 'text-gray-400'
            )}
          >
            <tab.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium leading-tight">{tab.name}</span>
          </Link>
        ))}
        {/* Daha Fazla butonu - sidebar'ı açar */}
        <button
          onClick={onMoreClick}
          className={cn(
            'flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors',
            isMoreActive ? 'text-maritime-600' : 'text-gray-400'
          )}
        >
          <Menu className="w-5 h-5" />
          <span className="text-[10px] font-medium leading-tight">{t('sidebar.more', { defaultValue: 'Daha Fazla' })}</span>
        </button>
      </div>
    </nav>
  );
}
